import { requestWithToken } from "../utils/apis";

export const fetchSettings = async () => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/settings`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const UpdateSettings = async (payload) => {
    try {
        const response = await requestWithToken(
            "PUT",
            `/api/settings`,
            payload
        );

        return response.data;
    } catch (err) {
        return err?.response?.data || {
            status: 0,
            message: "Failed to update settings",
        };
    }
};